exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".feedback-quote .feedback-review{width:auto;height:auto;background:#f8f8f8;position:relative;border-radius:10px}.feedback-quote .feedback-review:after{content:\"\";width:0;height:0;position:absolute;right:80%;top:100%;border-top:25px solid #f8f8f8;border-left:25px solid transparent}.feedback-quote .feedback-review{padding:15px}.feedback-quote .feedback-review q{font-style:italic;quotes:none}.feedback-quote .feedback-author{position:relative;font-weight:600;font-size:16px;left:6%;border:0;margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45dde3b1","scoped":false,"hasInlineConfig":true}!./src/components/feedback-quote/feedback-quote.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-45dde3b1","scoped":false,"hasInlineConfig":true}!./src/components/feedback-quote/feedback-quote.css
// module chunks = index